export default __webpack_public_path__ + "static/MLA logo-91564c911f461197c94ad4b1684f11c9.png";